import * as React from 'react';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { GatewayPaymentFragment } from '@websky/graphql';
import Gateway from '../Gateway';
import { PaymentPage, PaymentType } from '../../../types';
import * as css from './Kaspi.css';
import CopyCode from '../../CopyCode/CopyCode';

interface IKaspi {
	frameInfo: GatewayPaymentFragment;
	headerTitle?: string;
	onClick: (page: PaymentPage) => void;
	isPreOpened?: boolean;
	isAwaitingGatewayPayload?: boolean;
}

const Kaspi: React.FC<IKaspi> = ({
	frameInfo,
	headerTitle,
	onClick,
	children,
	isPreOpened,
	isAwaitingGatewayPayload
}) => {
	const { t } = useTranslation('PaymentForm');

	const onClickGateway = useCallback(() => {
		const paymentCode = frameInfo?.paymentCode;

		onClick({
			title: headerTitle,
			type: PaymentType.Kaspi,
			content: (
				<div className={css.root}>
					{paymentCode ? (
						<>
							{t('Payment code')}:
							<CopyCode className={css.copy} code={paymentCode} />
							<div className={css.info}>
								{t(
									'Please, click «Edit Order» after successful payment in Kaspi.kz APP to open your order.'
								)}
							</div>
						</>
					) : (
						t('Failed to get billing code')
					)}
				</div>
			)
		});
	}, [frameInfo, onClick]);

	useEffect(() => {
		if (isPreOpened && (frameInfo?.paymentCode || !isAwaitingGatewayPayload)) {
			onClickGateway();
		}
	}, [isPreOpened, frameInfo?.paymentCode, isAwaitingGatewayPayload]);

	return <Gateway onClick={onClickGateway} header={children} type={'Kaspi'} paymentType={PaymentType.Kaspi} />;
};

export default Kaspi;
